import { Component, type ErrorInfo, type ReactNode } from 'react';

/**
 * The last line of defence for one screen.
 *
 * React removes the whole tree when a render throws and nothing catches it;
 * on 4 October 2026 the owner opened production during a deploy and saw the
 * navbar over an empty page, and nothing on the screen said why. This
 * catches the throw below the navbar, so the person sees a sentence and a
 * button instead of white space, and the navigation stays usable. The
 * error goes to the console for whoever reads it next; the message carries
 * no customer data.
 */
export class ScreenBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('screen crashed', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="container">
        <div className="alert" role="alert">
          Obrazovku se nepodařilo vykreslit ({this.state.error.message || 'neznámá chyba'}).{' '}
          <button className="btn sm" type="button" onClick={() => window.location.reload()}>
            Obnovit stránku
          </button>
        </div>
      </div>
    );
  }
}
